'use client';

import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { alpha, Box, Button, Typography, useTheme } from '@mui/material';

import { useT } from '@/hooks';
import { colors } from '@/styles/theme';

interface ProfitLossHeaderProps {
  timeRange: string;
  onRangeChange: (range: string) => void;
}

const RANGES = ['1d', '1w', '1mo', 'ALL'];

export const ProfitLossHeader = ({ timeRange, onRangeChange }: ProfitLossHeaderProps) => {
  const theme = useTheme();
  const { t } = useT();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <TrendingUpIcon sx={{ color: colors.success.main, fontSize: 14 }} />
        <Typography
          variant="caption"
          sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.8rem' }}
        >
          {t('leaderboardPortfolio.profitLoss')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 0.5,
          bgcolor: alpha(theme.palette.text.primary, 0.04),
          p: 0.3,
          borderRadius: 1,
        }}
      >
        {RANGES.map((range) => (
          <Button
            key={range}
            onClick={() => onRangeChange(range)}
            size="small"
            sx={{
              minWidth: 32,
              height: 20,
              borderRadius: 0.8,
              fontSize: '0.6rem',
              fontWeight: 600,
              bgcolor: timeRange === range ? colors.accent.blue[600] : 'transparent',
              color: timeRange === range ? '#ffffff' : 'text.primary',
              '&:hover': {
                bgcolor:
                  timeRange === range
                    ? colors.accent.blue[700]
                    : alpha(theme.palette.text.primary, 0.08),
              },
            }}
          >
            {range}
          </Button>
        ))}
      </Box>
    </Box>
  );
};
